var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2029 5.75643C13.1534 5.74818 13.0957 5.74818 13.0462 5.75643C11.9079 5.71518 11.0005 4.78306 11.0005 3.62821C11.0005 2.44862 11.9491 1.5 13.1287 1.5C14.3083 1.5 15.2569 2.45687 15.2569 3.62821C15.2487 4.78306 14.3413 5.71518 13.2029 5.75643Z",
    fill: "#00A651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3528 11.7616C13.4829 11.9513 14.7285 11.7534 15.6029 11.1677C16.766 10.3923 16.766 9.12196 15.6029 8.34657C14.7202 7.7609 13.4582 7.56292 12.3281 7.76089",
    fill: "#00A651"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78868 5.77419C4.83838 5.76591 4.89636 5.76591 4.94606 5.77419C6.08916 5.73278 7.00033 4.79676 7.00033 3.6371C7.00033 2.45258 6.04775 1.5 4.86323 1.5C3.67872 1.5 2.72614 2.46087 2.72614 3.6371C2.73442 4.79676 3.64558 5.73278 4.78868 5.77419Z",
    fill: "#00A651"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64154 11.805C4.50672 11.9955 3.25594 11.7967 2.37791 11.2086C1.20997 10.43 1.20997 9.15432 2.37791 8.37569C3.26423 7.78758 4.53157 7.58877 5.66639 7.78757",
    fill: "#00A651"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99969 10.9725C8.95469 10.965 8.90219 10.965 8.85719 10.9725C7.82219 10.935 6.99719 10.0875 6.99719 9.03754C6.99719 7.96504 7.85969 7.10254 8.93219 7.10254C10.0047 7.10254 10.8672 7.97254 10.8672 9.03754C10.8597 10.0875 10.0347 10.9425 8.99969 10.9725Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81711 13.3345C5.75961 14.0395 5.75961 15.1945 6.81711 15.8995C8.01711 16.702 9.98211 16.702 11.1821 15.8995C12.2396 15.1945 12.2396 14.0395 11.1821 13.3345C9.98961 12.5395 8.01711 12.5395 6.81711 13.3345Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleLight);
export default __webpack_public_path__ + "static/media/people_light.829eae88cd269295e08b1c00b16c0431.svg";
export { ForwardRef as ReactComponent };